import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";

import ThemeProviderStyled from "./theme/ThemeProvider.styled";
import ShopRecentOrders from "./ShopRecentOrders";

const baseName = window.location.href.includes("localhost")
    ? window.location.pathname
    : "Shop";

const App = () => {
    return (
        <ThemeProvider theme={ThemeProviderStyled}>
            <Router basename={`${baseName}`}>
                <ShopRecentOrders />
            </Router>
        </ThemeProvider>
    );
};

export default App;
